import { environmentkeys } from "./environment-keys.qa";
const envType=environmentkeys.env;
const envPath=environmentkeys[envType];
export const environment = {
  production: true,
  env:envType,
  ...envPath
};
